import { useMemo, useState } from "react";
import { useDashboardData } from "@app/hooks/use-dashboard-data";
import { ComingSoonOverlay } from "@app/components/base/coming-soon-overlay";
import { ChargeApprovalsCard } from "./charge-approvals-card";
import { ChargeItemsStatusCard } from "./charge-items-status-card";
import { createDefaultDateRange } from "./dashboard-date-range";
import { DateRangeFilter } from "./date-range-filter";
import { SpendCard } from "./spend-card";
import { UnspentChargesCard } from "./unspent-charges-card";
import type { ApprovalsView, DashboardFilters, SpendDimension, UnspentView } from "./dashboard-types";

export function DashboardPage() {
    const defaultDateRange = useMemo(() => createDefaultDateRange(30), []);
    const [globalDateRange, setGlobalDateRange] = useState(defaultDateRange);
    const [chargeItemsDateRange, setChargeItemsDateRange] = useState(defaultDateRange);
    const [spendDimension, setSpendDimension] = useState<SpendDimension>("category");
    const [unspentView, setUnspentView] = useState<UnspentView>("user");
    const [approvalsView, setApprovalsView] = useState<ApprovalsView>("all");

    const filters: DashboardFilters = {
        globalDateRange,
        spendDimension,
        unspentView,
        approvalsView,
        chargeItemsDateRange,
    };

    const { spend, unspentCharges, approvals, chargeItemsByDay } = useDashboardData(filters);

    return (
        <ComingSoonOverlay title="Dashboard coming soon" description="Our dashboard is currently under development. We can't wait to share it with you.">
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>
                    <DateRangeFilter value={globalDateRange} onChange={setGlobalDateRange} />
                </div>

                <div className="grid grid-cols-1 items-stretch gap-4 xl:grid-cols-3">
                    <SpendCard segments={spend} dimension={spendDimension} onDimensionChange={setSpendDimension} />
                    <UnspentChargesCard items={unspentCharges} view={unspentView} onViewChange={setUnspentView} />
                    <ChargeApprovalsCard items={approvals} view={approvalsView} onViewChange={setApprovalsView} />
                </div>

                <ChargeItemsStatusCard items={chargeItemsByDay} dateRange={chargeItemsDateRange} onDateRangeChange={setChargeItemsDateRange} />
            </div>
        </ComingSoonOverlay>
    );
}
